<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:09:19
 * @LastEditTime: 2019-10-22 17:29:19
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="content">
    <div class="pageTitle">商品上架</div>
    <div class="formArea">
      <!-- :rules="rules" -->
      <el-form ref="form" :model="form"  :rules="rules" label-width="160px">
        <el-form-item label="选择商品:" prop="product_sn">
          <el-col :span="4">
            <el-input v-model="form.product_sn" readonly></el-input>
          </el-col>
          <el-col class="line" :span="1" style="text-align: center">-</el-col>
          <el-col :span="8">
            <el-input v-model="form.product_name " readonly></el-input>
          </el-col>
          <el-col :span="4" style="margin-left: 20px">
            <el-button type="primary" @click="selectProduct()" v-if='!$route.query.edit'>选择</el-button>
          </el-col>
        </el-form-item>
        <el-form-item>
          <img :src='img' alt />
        </el-form-item>
        <el-form-item label="是否赠品:">
            <el-checkbox  name="type" v-model="form.isgift"></el-checkbox>
            <span class="tips" style='color:#888;'>勾选为赠品后，填写的价格只作为展示之用，客户在线订购赠品时实际无需支付金额</span>
        </el-form-item>

        <el-form-item label="商品价格:" prop=""></el-form-item>
        <el-row>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="4">
            <el-form-item label="直属经销商:" prop="stock_out_time"></el-form-item>
          </el-col>
        </el-row>
        <el-row v-for="(v,k) in dealerLevel " :key='k'>
   
          <el-col :span="2">&nbsp;&nbsp;&nbsp;</el-col>
          <el-col :span='9'>
            <el-form-item :label="v.level_name" prop="">
              <el-input  v-model="dealerLevel[k].level_id" class="threeLeve" @input="change($event)"></el-input>元
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="4">
            <el-form-item label="直属门店:" prop="stock_out_time"></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">&nbsp;&nbsp;&nbsp;</el-col>
          <el-col :span='9'>
            <el-form-item label="直营门店:" prop="">
              <el-input v-model="form.directly_shop_directly_price" class="threeLeve"></el-input>元
            </el-form-item>
             <el-form-item label="非直营门店:" prop="">
              <el-input v-model="form.directly_shop_not_directly_price" class="threeLeve"></el-input>元
            </el-form-item>
          </el-col>
        </el-row>
         <el-row>
          <el-col :span="2">&nbsp;&nbsp;&nbsp;</el-col>
          <el-col :span='9' style='color:#f04635;margin-bottom:20px;'>
              提示：不填写代表对应类型的客户无此商品的订购权限，商品不可见
          </el-col>
        </el-row>
          <el-row>
          <el-col :span="2">&nbsp;&nbsp;&nbsp;</el-col>
          <el-col :span='9' v-show='!is_nsb'>
        
            <el-form-item label="非直属 经销商:" prop="stock_out_time">
               <el-checkbox-group v-model="form.not_directly_dealer_extend_directly_dealer_price " style="display:inline-block">
                    <el-checkbox label='1' name="type">继承直属价格</el-checkbox>
                </el-checkbox-group>
                    <span class='tipsIcon'>?</span>
                    <div class='text'>勾选后,非直属的经销商或门店订购价格就继承上面设置的直属价格，不勾选则代表非直属不能在线订购该商品,但如果系统设置了允许经销商自定义商品价格，则无论是否勾选继承直属价格,非直属经销商的订货价格的都可以根据上级经销商设置的价格订购</div>
           
            </el-form-item>
             <el-form-item label="非直属门店:" prop="stock_out_time">
                  <el-checkbox-group v-model="form.not_directly_shop_extend_directly_shop_price">
                    <el-checkbox label='1' name="type">继承直属价格</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="失效时间" prop="">
          <el-date-picker
            v-model="expire_time"
            type="datetime"
            placeholder="选择失效时间">
          </el-date-picker>
          <span style="color:gray;"> 非必填，设置失效时间后，当达到失效时间系统会自动下架商品</span>
        </el-form-item>
        <el-form-item label="商品属性" v-if='is_show_attribute==1&&!is_gift'>
           <el-radio-group v-model="form.attribute_id" style='display:inline-block;margin-right:20px;'>
                <el-radio :label="v.attribute_id" v-for="(v,k) in attributeList" :key='k' :checked='v.is_default==1'>{{v.attribute_name}}</el-radio>
            </el-radio-group>
            <a href="javascript:;" style='color:blue' @click='dialogVisible=!dialogVisible'>设置商品属性</a>
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="save('form')">保存</el-button>

    </div>
            <el-dialog
                :visible.sync="dialogVisible"
                width="40%"
                :before-close="handleClose">
                <div class="btnBox">
            <el-button type="primary" @click="detail=!detail,type='add'">添加商品属性</el-button>
            <ul>
                <li class='clearfix detailList' v-for="(v,k) in attributeList" :key='k'>
                    <div class='fl'>
                        <span style="margin-right:13px">ID:{{v.attribute_id}}</span>
                    <span>{{v.attribute_name}}</span>
                    </div>
                    <div class='fr'>
                    <span><el-button  type="text" @click="editAttr(v)">编辑</el-button></span>
           
                    <span><el-button  type="text" @click="delAttr(v)">删除</el-button></span>
                    </div>
                </li>
            </ul>
      
        </div>
        </el-dialog>
            <el-dialog
                :visible.sync="detail"
                width="40%"
                :before-close="handleClose">
                <div class="btnBox">
                      
                        商品属性名称:<el-input  label="" v-model="attribute_name" class="threeLeve" maxlength="6"></el-input>({{attribute_name.length}}/6)
                        <br/>
           <el-button style='margin-top:20px;' type="primary" @click="saveAttr()">保存</el-button>

        </div>

        </el-dialog>
           <!--批量导入-->
        <!-- <importData v-if="importDataDialog" v-on:handleClose='importDataDialog = false'
                    @refresh="onSearch">
        </importData> -->
         <product
      v-if="Product"
      v-on:handleClose=" Product = false"
      @pushData="select"
    />
  </div>
</template>

<script>
import product from './product'
    // import importData from './importData';

export default {
  name: "general-onput",
  data() {
    return {
      form: {
        product_category_id :'',
        product_name :'',
        product_sn :'',
        product_id :'',
        product_bar_code:'',
        attribute_id:'',
        isgift:false,
        directly_shop_not_directly_price:'',
        not_directly_dealer_extend_directly_dealer_price:"",
        directly_shop_directly_price:'',
        directly_shop_not_directly_price:'',
        expire_time: '',
      },
      is_nsb:false,
      img:'',
      Product:false,
      dialogVisible:false,//商品属性列表
      detail:false,//新增商品属性
      checkList:[],
      rules:{product_sn:[
            { required: true, message: '请选择商品', trigger: 'blur' },
          ],
          directly_shop_not_directly_price:[
            { required: true, message: '请输入非直营门店价格', trigger: 'blur' },
          ],
          directly_shop_directly_price:[
            { required: true, message: '请输入直营门店价格', trigger: 'blur' },
          ]
          },
      dealerLevel:[],
      is_show_attribute:1,
      attributeList:[],
      attribute_name:'',
      type:'add',
      attribute_id:'',
      is_gift:false,
      expire_time: '',
    };
  },
  watch: {
  form: {
    handler(newName, oldName) {
     if(this.form.isgift){
       this.is_gift=true
     }else if(this.form.isgift!=2){
       this.is_gift=false
     }
    },
    immediate: true,
    deep: true
  }
} ,
  methods: {
    // 初始化
    init(){
      if(this.$route.query.edit){
        var url='/product.putaways/'+this.$route.query.edit
        this.$get('logistics',url).then(res=>{
          this.form=res.data
          this.form.not_directly_dealer_extend_directly_dealer_price=this.form.not_directly_dealer_extend_directly_dealer_price==1?true:false
          this.form.not_directly_shop_extend_directly_shop_price=this.form.not_directly_shop_extend_directly_shop_price==1?true:false
          this.form.isgift=this.form.isgift==1?true:false
          this.expire_time = this.form.expire_time
          this.form.directly_dealer_price.forEach(v => {
                this.dealerLevel.forEach((element,index) => {
                    if(element.id==v.level_id){
                      this.dealerLevel[index].level_id=v.price
                    }
                });
          });

        })
      }
      //判断是否是纽斯葆
      if(this.$cookies.get('customer_id')=='10000044'){
        this.is_nsb=true
      }
    },
    // 获取一些配置
    getConfig(){
      this.$get('logistics','/configs.order').then(res=>{
        this.is_show_attribute=res.data.product_attribute_on_off
        if(this.is_show_attribute==1){
          this.getAttribute()
        }
      })
    },
    getAttribute(){
      this.$get('logistics','/product.attributes').then(res=>{
        this.attributeList=res.data
        res.data.forEach(element => {
            if(element.is_default==1){
               this.form.attribute_id=element.attribute_id
            }
        });
       
      })
    },
      //获取经销商级别
                getDealerLevel() {
                    this.$get('logistics', '/dealers.level', {}).then(res => {
                        this.dealerLevel = res.data;
                        this.init()
                    }).catch(function (error) {
                    });
                },
    selectProduct() {
      this.Product=!this.Product
    },
    select(value){
      
      this.img=value.product_img
      this.form.product_id=value.product_id
      this.form.product_name=value.product_name
      this.form.product_sn=value.product_sn
      this.form.product_category_id=value.product_category_id
    this.form.product_bar_code=value.product_bar_code
    
    },
    handleClose(done){
        done()
    },
    // 保存新增商品属性  或 保存编辑商品属性
    saveAttr(){
      if(this.attribute_name==''){
        this.$message({
          type:'error',
          message:'情输入属性名'
        })
        return
      }
      if(this.type=='add'){
        this.$post('logistics','/product.attributes',{
        attribute_name :this.attribute_name 
      }).then(res=>{
        this.detail=false
        this.getAttribute()
           this.$message({
          type:'success',
          message:'保存成功'
        })
        this.attribute_name =''
      }).catch(error=>{
        this.detail=false
          this.$message({
          type:'error',
          message:error.message
        })
      })
      }else{
        var url='/product.attributes/'+this.attribute_id
        this.$put('logistics',url,{
        attribute_name :this.attribute_name,
        _method:'PUT'
      }).then(res=>{
        this.detail=false
        this.getAttribute()
           this.$message({
          type:'success',
          message:'保存成功'
        })
        this.attribute_name =''
      }).catch(error=>{
        this.detail=false

          this.$message({
          type:'error',
          message:error.message
        })
      })
      }
    },
    // 编辑商品属性
    editAttr(data){
      this.detail=!this.detail
      this.attribute_name=data.attribute_name
      this.attribute_id=data.attribute_id
      this.type='edit'
    },
    // 删除商品属性
    delAttr(data){
       this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(res=>{
          var url='/product.attributes/'+data.attribute_id
          this.$delete('logistics',url,{
            _method :'DELETE'
          }).then(res=>{
            this.$message({
              type:'success',
              message:'删除成功',
            })
          }).catch(error=>{
             this.$message({
              type:'error',
              message:error.message,
            })
          })
      })
    },
    change(e){
      this.$forceUpdate()
    },
    // 保存 数据
    save(){
         this.$refs.form.validate((valid) => {
          if (valid) {
            // 处理 是否赠品数据
            this.form.isgift=this.form.isgift?1:2
            // 处理直属经销商的 价钱 数据
            var prices=[]
              this.dealerLevel.forEach(element => {
                  if(element.level_id){
                    prices.push({
                      level_id:element.id,
                      price:element.level_id
                    })
                    // 用 element.level_id 绑定价钱的 key值
                  }
              });
              this.form.directly_dealer_price=JSON.stringify(prices)
// 
            // 处理数据
              this.form.not_directly_shop_extend_directly_shop_price=this.form.not_directly_shop_extend_directly_shop_price?1:0
              this.form.not_directly_dealer_extend_directly_dealer_price=this.form.not_directly_dealer_extend_directly_dealer_price?1:0
              if( this.expire_time != '' ){
                  this.form.expire_time = this.imeFormat(this.expire_time);
              }
              if(this.is_show_attribute!=1|| this.is_gift){
                delete this.form.attribute_id;
              }
            if(!this.$route.query.edit){
              // 
            
              this.$post('logistics','/product.putaways',{
                ...this.form
              }).then(res=>{
                this.$message({
                  type:'success',
                  message:'保存成功'
                })
                this.$router.push({
                  name:'goodsOnput'
                })
              }).catch(error=>{
                this.$message({
                  type:'error',
                  message:error.message
                })
                 this.form.isgift=this.form.isgift==1?true:false
              })
            }else{
            var url='/product.putaways/'+this.$route.query.edit
            this.$put('logistics',url,{
              ...this.form,
              _method :'PUT',
              
            }).then(res=>{
                   this.$message({
                  type:'success',
                  message:'修改成功'
                })
               this.$router.push({
                  name:'goodsOnput'
                })
            }).catch(error=>{
                      this.$message({
                  type:'error',
                  message:error.message
                })
            })
            }
            
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
    imeFormat(Time){
        if(!Time) return '';
        var time = new Date(Time);
        var year = time.getFullYear();
        var month = time.getMonth()+1;
        var date = time.getDate();
        var hours = time.getHours();
        var minutes = time.getMinutes();
        var seconds = time.getSeconds();
        function add0(m){return m<10?'0'+m:m }
        var startTime = add0(year) + '-' + add0(month) + '-' + add0(date) + ' ' + add0(hours) + ':' + add0(minutes) + ':' + add0(seconds)
        return startTime
    },
  },
  components:{
      product
  },
  created() {
    this.getDealerLevel()
    this.getConfig()
    // this.init()
  }
};
</script>

<style lang="scss" scoped>
.content {
  .formArea {
    margin: 20px;
  }
}
.threeLeve {
  display: inline-block;
  width: 250px;
  margin-right: 20px;
}
.detailList{
    background-color: #eee;
    padding: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
  /deep/  button{
     margin: 0!important;
     padding: 0;
     line-height: inherit;
   }
}
img{
 width: 150px;
}
.tipsIcon{
  display: inline-block;
  width:20px;
  height: 20px;
  background-color: rgb(65, 68, 78);
  border-radius: 50%;
  color: #fff;
  line-height: 20px;
  text-align: center;
  margin-left: 10px;
}
.tipsIcon:hover~.text{
  opacity: 1;
  
}
.text{
  width: 300px;
  position: absolute;
  background-color: rgb(65, 68, 78);
  color: #fff;
  z-index: 1000;
  border-radius: 25px;
  padding: 5px;
  right: -10%;
  top: -240px;
  opacity: 0;
}
.text::before{
  width: 20px;
  height: 20px;
  position: absolute;
  bottom: 0;
  left: 0;
  background-color:#fff;
}
</style>